import React from 'react'
import { useTranslation } from 'react-i18next'
import { Tag } from 'src/components/basic/tag'

type PropTypes = {
  title: string
  icon: string
  onClickHandler: Function
  bgColor: 'blue' | 'purple' | 'cyan'
  tabIndex: number
  testid?: string
  isBeta?: boolean
}

const MenuDynamicItem = ({ title, icon, onClickHandler, bgColor, tabIndex, testid, isBeta }: PropTypes) => {
  const { t } = useTranslation()

  return (
    <hot-dropdown-menu-item
      slot="menu"
      class="header-tools__item _position-relative"
      onClick={onClickHandler}
      tabIndex={tabIndex}
      data-testid={testid}
    >
      {isBeta && (
        <Tag type="red" size="sm" className="header-tools__tag _position-absolute">
          {t('header.menu.general.beta')}
        </Tag>
      )}
      <span className={`_p-4 _rounded-lg _mb-1 ${bgColor}`}>
        <img src={icon} alt={title} width={32} height={32} />
      </span>
      <span className="_flex-1">{title}</span>
    </hot-dropdown-menu-item>
  )
}

export default MenuDynamicItem
